module.exports = " <div class=von-cascade-panel :class=\"{'active': state == 1}\"> <div class=title> {{ title }} </div> <div class=\"list options\" thin-border> <div class=item v-for=\"($index, option) in options\" @click=optionClicked($index)> {{ option }} </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cascade/CascadePanel.vue
// module id = 231
// module chunks = 0